export const APP_SETTINGS = {
  url: 'v1/backoffice/settings',
  method: 'GET',
  reducerKey: 'appSettings',
};
